module.exports = __webpack_public_path__ + "media/iphone1.c2b57268.webm";